<template>
  <div class="card" v-if="thesis.id > 0">
    <div
      class="alert alert-success"
      v-bind:class="alert.type"
      role="alert"
      v-if="alert.text.trim() !== ''"
      v-html="alert.text.trim()"
    ></div>
    <div class="card-header" v-html="Translate('@_GRADE')"></div>
    <div class="card-header" v-html="Translate('@_THESIS') + ' ' + thesis.code"></div>
    <div
      class="card-header"
      style="background-color: rgba(0, 0, 0, 0.05);"
      v-html="Translate('@_THESIS_TITLE_STATUS_AND_HOWMANY').replaceArray(['[|STATUS|]', '[|HOWMANY|]'], [Translate(thesis.statustext), thesis.howManyStudentsAllow])"
    ></div>
    <div v-if="isProfessor || isAdmin">
      <table class="tg" v-for="(student, index) in students" v-bind:key="index">
        <br />
        <span v-html="Translate('@_USER_TYPE_2') + ': ' + student.name"></span>
        <tr>
          <th class="tg-0lax"></th>
          <th v-for="(teacher, index) in teachers" v-bind:key="index">
            <span v-html="teacher.name"></span>
          </th>
        </tr>

        <tr v-for="(gradesh, index) in gradesHeader" v-bind:key="index">
          <td
            class="tg-0lax"
            v-html="Translate('@_' + gradesh.toUpperCase()) + ' x ' + settings.thesis.grade.find(g => g.type === gradesh.toLowerCase()).rate.toFixed(1)"
          ></td>

          <td class="tg-0lax" v-for="(teacher, i) in teachers" v-bind:key="i">
            <input
              v-bind:disabled="thesis.status == settings.thesis.status.completed"
              type="text"
              :name="gradesh + '_' + student.id + '_' + teacher.id"
              class="form-control"
              :value="getGrade(student.id, teacher.id, index)"
            />
          </td>
        </tr>
        <tr>
          <td class="tg-0lax" v-html="Translate('@_SUM') + ':'"></td>
          <td
            class="tg-0lax"
            v-for="(teacher, i) in teachers"
            v-bind:key="i"
            v-html="getGrade(student.id, teacher.id, 4)"
          ></td>
        </tr>
        <p v-html="'Τελικός Βαθμός ανα Φοιτητή: '+getGrade(student.id, 0, 5)"> </p>
      </table>

      <br />
      <br />
      <button
        type="button"
        class="col-sm btn btn-outline-info float-center"
        v-bind:disabled="thesis.status != settings.thesis.status.pending_for_exam_and_grading"
        v-on:click.prevent="saveGrades(0)"
        v-html="Translate('@_SAVE_GRADES')"
      ></button>
      <br />
      <br />
      <span v-html="Translate('@_TOTAL_GRADE')"></span>
      : {{ this.thesis.totalgrade }}
      <br />
      <br />
      <button
        type="button"
        class="col-sm btn btn-outline-danger float-center"
        v-bind:disabled="thesis.status != settings.thesis.status.pending_for_exam_and_grading"
        v-on:click.prevent="finalizeGrades()"
        v-html="Translate('@_FINALIZE_GRADES')"
      ></button>
    </div>
  </div>
</template>

<script>
import Mixin from "@/helpers/mixin";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "Thesis",
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  mixins: [Mixin],
  components: {},
  data() {
    return {
      inputsform: {},
      alert: {
        type: "",
        text: ""
      },
      message: "",
      thesis: {
        id: null,
        code: null,
        status: null,
        howManyStudentsAllow: null,
        titleEl: "",
        abstractEl: "",
        titleEn: "",
        abstractEn: "",
        file: null,
        totalgrade: null
      },
      teacher1: null,
      students: [],
      teachers: [],
      gradesHeader: ["Analysis", "Goals", "Quality", "Presentation"],
      grades: null,
      gradej: {
        thesisid: 1,
        studentid: 2,
        teacherid: 28,
        analysis: 5,
        goals: 6,
        quality: 7,
        presentation: 8
      }
    };
  },
  computed: {},
  methods: {
    finalizeGrades() {
      var r = confirm(this.Translate("@_ARE_YOU_SURE"));
      if (r !== true) {
        return;
      }
      this.saveGrades(1);
    },
    saveGrades(fin) {
      let str = "[";
      for (let i = 0; i < this.students.length; i++) {
        for (let j = 0; j < this.teachers.length; j++) {
          str +=
            '{"thesisid":' +
            this.thesis.id +
            ',"studentid":' +
            this.students[i].id +
            ',"teacherid":' +
            this.teachers[j].id +
            ',"analysis":' +
            document.getElementsByName(
              "Analysis_" + this.students[i].id + "_" + this.teachers[j].id
            )[0].value +
            ',"goals":' +
            document.getElementsByName(
              "Goals_" + this.students[i].id + "_" + this.teachers[j].id
            )[0].value +
            ',"quality":' +
            document.getElementsByName(
              "Quality_" + this.students[i].id + "_" + this.teachers[j].id
            )[0].value +
            ',"presentation":' +
            document.getElementsByName(
              "Presentation_" + this.students[i].id + "_" + this.teachers[j].id
            )[0].value +
            "}";
          if (i != this.students.length - 1 || j != this.teachers.length - 1)
            str += ",";
        }
      }
      str += "]";

      this.$store
        .dispatch("http_save_grades", {
          data: str,
          fin: fin
        })
        .then(() => {
          location.reload();
        })
        .catch(e => {
          alert(e.body);
          console.error(e);
        });
    },
    getGrade(studentId, teacherId, kind) {

      let sum = 0;
      for (let i = 0; i < this.grades.length; i++) {
        if (
          this.grades[i].student_id == studentId &&
          this.grades[i].teacher_id == teacherId
        ) {
          if (kind == 0) return this.grades[i].analysis;
          if (kind == 1) return this.grades[i].goals;
          if (kind == 2) return this.grades[i].quality;
          if (kind == 3) return this.grades[i].presentation;
          if (kind == 4) return this.grades[i].calculatedgrade;
        }

        if (this.grades[i].student_id == studentId && kind == 5)
        {
          sum = sum + parseFloat(this.grades[i].calculatedgrade)/3;
        }
      }
      return sum.toFixed(2);
    },
    goBack() {
      this.$router.go(-1);
    },
    goToView(InThesisId) {
      this.$router
        .push({
          name: "thesis_view",
          params: { id: parseInt(InThesisId) }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getThesis(InId) {
      this.$store
        .dispatch("http_get_thesis", {
          id: parseInt(InId)
        })
        .then(resp => {
          if (resp.length > 0) {
            this.result = resp[0];
            this.thesis.id = parseInt(this.result.id);
            this.thesis.code = parseInt(this.result.code);
            this.thesis.status = parseInt(this.result.status);
            this.thesis.statustext = this.result.statustext;
            this.thesis.file = this.result.file;
            this.thesis.totalgrade = this.result.totalgrade;
            this.thesis.howManyStudentsAllow = parseInt(
              this.result.howmanystudentsallow
            );
            this.thesis.titleEl = String(this.result.titleEl).trim();
            this.thesis.titleEn = String(this.result.titleEn).trim();
            this.thesis.abstractEl = String(this.result.abstractEl).trim();
            this.thesis.abstractEn = String(this.result.abstractEn).trim();
            if (this.result.student1 !== null) {
              this.students.push({
                id: parseInt(this.result.student1),
                am: String(this.result.student1_am).trim(),
                name: String(this.result.student1_name).trim(),
                email: String(this.result.student1_email).trim()
              });
            }
            if (this.result.student2 !== null) {
              this.students.push({
                id: parseInt(this.result.student2),
                am: String(this.result.student1_am).trim(),
                name: String(this.result.student2_name).trim(),
                email: String(this.result.student2_email).trim()
              });
            }
            if (this.result.teacher1 !== null) {
              this.teachers.push({
                id: parseInt(this.result.teacher1),
                name: String(this.result.teacher1_name).trim(),
                email: String(this.result.teacher1_email).trim()
              });
            }
            if (this.result.teacher2 !== null) {
              this.teachers.push({
                id: parseInt(this.result.teacher2),
                name: String(this.result.teacher2_name).trim(),
                email: String(this.result.teacher2_email).trim()
              });
            }
            if (this.result.teacher3 !== null) {
              this.teachers.push({
                id: parseInt(this.result.teacher3),
                name: String(this.result.teacher3_name).trim(),
                email: String(this.result.teacher3_email).trim()
              });
            }
          }
        })
        .catch(e => {
          console.error(e);
        });
    },
    getGrades(InId) {
      this.$store
        .dispatch("http_get_grades", {
          id: parseInt(InId)
        })
        .then(resp => {
          this.grades = resp;
        })
        .catch(e => {
          console.error(e);
        });
    },
  },
  created() {
    this.getThesis(this.id);
    this.getGrades(this.id);
  }
};
</script>

<style scoped>
.tg {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border-color: #9abad9;
}
.tg td {
  font-family: Arial, sans-serif;
  font-size: 14px;
  padding: 10px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  border-color: #9abad9;
  color: #444;
  background-color: #ebf5ff;
}
.tg th {
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-weight: normal;
  padding: 10px 5px;
  border-style: solid;
  border-width: 1px;
  overflow: hidden;
  word-break: normal;
  border-color: #9abad9;
  color: #fff;
  background-color: #007bff;
}
.tg .tg-baqh {
  text-align: center;
  vertical-align: top;
}
</style>
